module.exports = __webpack_public_path__ + "img/right3 (1).eff6f9c2.png";